import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const TimerIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.59961 16.5C4.18851 16.5 0.599609 12.9111 0.599609 8.5C0.599609 4.0889 4.18851 0.5 8.59961 0.5C13.0107 0.5 16.5996 4.0889 16.5996 8.5C16.5996 12.9111 13.0107 16.5 8.59961 16.5ZM8.59961 2C5.01561 2 2.09961 4.916 2.09961 8.5C2.09961 12.084 5.01561 15 8.59961 15C12.1836 15 15.0996 12.084 15.0996 8.5C15.0996 4.916 12.1836 2 8.59961 2Z"
          fill="#ADACA8"
        />
        <path
          d="M8.89554 3.52679C8.69044 3.51409 8.48734 3.58829 8.33694 3.72939C8.18654 3.87099 8.10114 4.06879 8.10114 4.27529V8.43939L5.34284 11.1977C5.19494 11.3456 5.11534 11.5483 5.12364 11.7573C5.13194 11.9668 5.22714 12.1626 5.38634 12.2983C6.29404 13.0732 7.43564 13.5 8.60114 13.5C11.3579 13.5 13.6011 11.2568 13.6011 8.49999C13.6011 5.86819 11.5342 3.68349 8.89554 3.52679Z"
          fill="#ADACA8"
        />
      </svg>
    </SvgIcon>
  )
}

export default TimerIcon
